import React, { FC } from 'react';
import { Route } from 'react-router';

import { EquipsUnitsPage } from '@app/components/equipments-units-guides';

const EquipmentsUnitsPage: FC = () => {
  return (
    <>
      <Route
        exact
        path="/equipments-units"
        component={EquipsUnitsPage}
      />
    </>
  );
};

export default EquipmentsUnitsPage;
